import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDContentContainer, FDEmphasisSurface } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { LottieLoadingLayout } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import { dispatchAccountStatusChangedRefresh } from 'Hooks/useRefreshEvent';
import { AccountOpeningV2FinishStepLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

export const AccountOpeningV2FinishStepTemplate = ({ resource }) => {
  React.useEffect(() => {
    dispatchAccountStatusChangedRefresh();
  }, []);

  return (
    <LottieLoadingLayout>
      <FDContentContainer maxWidth="sm">
        <FDEmphasisSurface padding={4}>
          <MetaResourceRenderer
            metaOverrideSet={metaOverrideSet}
            layout={AccountOpeningV2FinishStepLayout}
            resource={resource}
          />
        </FDEmphasisSurface>
      </FDContentContainer>
    </LottieLoadingLayout>
  );
};

AccountOpeningV2FinishStepTemplate.defaultProps = {
};

AccountOpeningV2FinishStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
